import { Card, IconButton } from '@looker/components';
import styled from 'styled-components';

export const StyledCard = styled(Card)`
  width: 100%;
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  padding: 8px;
`;

export const StyledInnerCard = styled(Card)`
  border-radius: 6px;
  background: rgba(205, 209, 212, 0.19);
  border: none;
  padding: 10px 16px;
  min-height: 68px;
  margin-bottom: 4px;
  cursor: pointer;
`;

export const Divider = styled('div')`
  flex-grow: 1;
`;

export const StyledIconButton = styled(IconButton)`
  margin-left: auto;
`;

export const Spacer = styled('div')`
  margin: 4px;
`;
